import { MutationOptions, useMutation } from "react-query";
import { API_URL, APIError, APIResponse, post } from "../api";

interface VerifyVariables {
  email: string;
}

function useResend2FA(
  options?: MutationOptions<APIResponse<string>, APIError, VerifyVariables>,
) {
  const {
    isLoading,
    isError,
    error,
    mutate: resendOTP,
  } = useMutation<APIResponse<string>, APIError, VerifyVariables>(
    async (variables) => {
      return await post(API_URL + "/auth/user/resend-two-factor", variables, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    options,
  );

  return {
    resendOTP,
    isResending: isLoading,
    isResendError: isError,
    resendError: error,
  };
}

export default useResend2FA;
